import {course_getCourseClassById_Api,} from 'apis'
import {TabNavigation} from '../../../Shared/components/TabNavigation'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useContext, useEffect, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {CourseContainerContext} from "./CourseContainer";
import {BsArrowLeftCircle, BsCalendar2Week, BsGearFill} from "react-icons/bs";
import _ from "lodash"
import useTranslate from "../../../../modules/local/useTranslate";
import {PiChecks, PiGraduationCap, PiTextSuperscriptBold} from "react-icons/pi";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {CourseClassSubjectList} from "../../../AppLocals/Course/CourseClass/components/CourseClassSubjectForm";
import {useCourseClassForm} from "../../../AppLocals/Course/CourseClass/useCourseClassForm";
import {CourseClassStudentList} from "../../../AppLocals/Course/CourseClass/CourseClassStudentForm";
import CourseClassTeachers from "../../../AppLocals/Course/CourseClass/CourseClassTeachers";
import {EditCourseClassModal} from "../../../AppLocals/Course/CourseClass/CourseClassForm";
import {NullAsDefault} from "../../../Shared";
import {useCourseClassApi} from "../../../AppLocals/Course/CourseClass/useCourseClassApi";
import {ClassActionTypes} from "../../../AppLocals/Course";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {FaUserGraduate, FaUserTie} from "react-icons/fa6";
import getTitle from "../../../../helpers/getTitle";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {ItemInformation} from 'components/common/ItemInformation'
import {AiFillDelete} from "react-icons/ai";
import {GoDotFill} from "react-icons/go";
import {CourseClassAttendancePanel} from "./CourseClassList/CourseClassAttendancePanel";
import {CourseClassGradingPanel} from "./CourseClassList/CourseClassGradingPanel";
import {CourseClassTimetablePanel} from "./CourseClassList/CourseClassTimetablePanel";
import useScrollHide from "../../../../hooks/useScrollHide";
import classNames from "classnames";

const CLASS_TABS = [
    {key: 'schedule',   name: 'timetable',   icon: <BsCalendar2Week size={18}/>},
    {key: 'subject',    name: 'subject',      icon: <PiTextSuperscriptBold size={18}/>},
    {key: 'student',    name: 'student',      icon: <FaUserGraduate size={15}/>},
    {key: 'teacher',    name: 'teacher',      icon: <FaUserTie size={15}/>},
    {key: 'attendance', name: 'attendance',   icon: <PiChecks size={16}/>},
    {key: 'grading',    name: 'gradebook',    icon: <PiGraduationCap size={16}/>},
    {key: 'settings',   name: 'class settings', icon: <BsGearFill size={16}/>},
    {key: 'destroy',    name: 'delete content', icon: <AiFillDelete size={16}/>},
];


const CourseClassDetail = ({}) => {
    const t = useTranslate();
    const courseClassDetailTab = useRouteSearchParam("course-class-detail-tab") || "schedule"
    const [activeTab, setActiveTab] = useState(courseClassDetailTab);
    const [selectedCourseClass, setSelectedCourseClass] = useState({});
    const {
        current_course_id, setCurrentCourseId,
        current_course_class_id, setCurrentCourseClassId,
        onSelectCourseContainerRoute
    } = useContext(CourseContainerContext);

    const {handleAsyncAction: getCourseClassById} = useAsyncAction({
        apiInfo: course_getCourseClassById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setSelectedCourseClass(dataItem);
        },
    })
    const {onChangeSearchParams} = useRouterSearchParam({})

    const course = _.get(selectedCourseClass, 'course', {});
    const {
        modal: courseClassModal,
        handleAction: handleCourseClassAction,
        onCancel: onCourseClassCancel,
    } = useCourseClassForm({course})
    const {
        onUpdate: onCourseClassUpdate
    } = useCourseClassApi({
        onUpdated: NullAsDefault,
    })

    useEffect(() => {
        if (current_course_class_id) {
            getCourseClassById({}, {id: current_course_class_id})
        }
    }, [current_course_class_id])

    const renderCourseClassContent = () => {
        switch (activeTab) {
            case 'schedule':
                return <CourseClassTimetablePanel item={selectedCourseClass}/>
            case 'subject':
                return (
                    <div className="flex flex-col gap-3">
                        <h3 className="font-bold text-sm text-gray-700 uppercase tracking-wide">
                            {t('subjects')} ({_.get(selectedCourseClass, 'class_subjects', []).length})
                        </h3>
                        {!!selectedCourseClass?.id && bindingSearch({
                            onCancel: onCourseClassCancel,
                            item: selectedCourseClass,
                        })(CourseClassSubjectList)}
                    </div>
                );
            case 'student':
                return (
                    <div className="flex flex-col">
                        {!!selectedCourseClass?.id && bindingSearch({
                            onCancel: onCourseClassCancel,
                            owner_id: selectedCourseClass?.owner?.id,
                            owner_type: selectedCourseClass?.owner?._type,
                            item: selectedCourseClass,
                        })(CourseClassStudentList)}
                    </div>
                );
            case 'teacher':
                return (
                    <div className="flex flex-col">
                        {!!selectedCourseClass?.id && bindingSearch({
                            onCancel: onCourseClassCancel,
                            owner_id: selectedCourseClass?.owner?.id,
                            owner_type: selectedCourseClass?.owner?._type,
                            item: selectedCourseClass,
                        })(CourseClassTeachers)}
                    </div>
                );
            case 'attendance':
                return <CourseClassAttendancePanel item={selectedCourseClass}/>
            case 'grading':
                return <CourseClassGradingPanel item={selectedCourseClass}/>
            case 'settings':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("class settings")}
                        </h3>
                        <div className="mb-4 text-color-300 tracking-wider">
                            {t("manage name description start end dates")}
                        </div>
                        <div className="my-3 flex flex-col gap-1">
                            <label className="text-sm font-medium text-color-200 tracking-wider">
                                {t('belong to the course')}
                            </label>
                            <div className="p-3 flex flex-col border border-color-50 shadow rounded-lg">
                                <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                                    <Link to={getLinkToDetail(course)} className="font-bold text-base text-color-000 tracking-wide">
                                        {getTitle(course)}
                                    </Link>
                                </div>
                                <div className="flex flex-col flex-1 gap-1">
                                    {(course?.academic_field !== null || course?.academic_year !== 0) && (
                                        <div
                                            style={{ padding: '3px 8px', fontSize: 11, borderRadius: 999, wordBreak: 'break-all' }}
                                            className="w-fit border border-primary-400 font-medium text-primary-700 italic leading-tight min-w-0 max-lines-1">
                                            {course?.academic_field}
                                            {(course?.academic_year !== 0 && course?.academic_field !== null) ? ` - ${course?.academic_year}` : course?.academic_year !== 0 ? course?.academic_year : ''}
                                        </div>
                                    )}
                                    {_.some([course?.time_open, course?.time_close]) && (
                                        <DoubleValueItem
                                            showIcon={true}
                                            labelFirst="time"
                                            valueFirst={formatSimplifyDate(course?.time_open, 'medium')}
                                            labelSecond={course?.time_close && ' - ' || ''}
                                            valueSecond={course?.time_close && formatSimplifyDate(course?.time_close, 'medium')}
                                            className="text-xs italic"
                                        />
                                    )}
                                    {course?.last_enrollment_time && (
                                        <ItemInformation
                                            showIcon={true}
                                            label="last enrollment time"
                                            value={formatSimplifyDate(course?.last_enrollment_time, 'medium')}
                                            className="text-xs italic tracking-wide"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {!!selectedCourseClass?.id && (
                            <EditCourseClassModal
                                item={selectedCourseClass}
                                owner_id={course?.owner?.id}
                                owner_type={course?.owner?._type}
                                container={course}
                                initialValues={selectedCourseClass}
                                onCancel={onCourseClassCancel}
                                onSubmit={(values) => {
                                    onCourseClassUpdate(values, {id: selectedCourseClass?.id})
                                }}
                            />
                        )}
                    </div>
                );
            case 'destroy':
                return (
                    <div className="flex flex-col">
                        <div className="bg-white p-4 rounded-xl shadow-lg border-l-4 border-red-500">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("delete class")}
                            </h3>
                            <div className="mb-4 text-color-300 tracking-wider">
                                {t("this action will permanently delete the class and all related data please confirm before proceeding")}
                            </div>
                            <div className="flex justify-end">
                                <button
                                    onClick={() => {
                                        handleCourseClassAction(ClassActionTypes.CLASS_DELETE, selectedCourseClass)
                                    }}
                                    className="px-6 py-2 bg-red-600 hover:bg-red-700 shadow-md rounded-lg font-medium text-white"
                                >
                                    {t("delete class permanently")}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const {coordinators = [], class_subjects = []} = selectedCourseClass ?? {}
    const firstCoordinator = coordinators[0]

    const {hidden} = useScrollHide()

    return (
        <div className="w-full min-h-screen">
            <div className={classNames("mb-6 p-4 background shadow-lg rounded-b-xl z-12", hidden ? 'stickyTop' : 'stickyTop1')}>
                <button
                    onClick={() => {
                        onSelectCourseContainerRoute({current_course_class_id: ''})
                    }}
                    className="mb-2 flex items-center text-color-300 hover:text-color-100 tracking-wide cursor-pointer">
                    <BsArrowLeftCircle size={18} className="mr-2"/>
                    {`${t("back to course")} :`}
                    <span className="ml-1 font-medium text-primary-800 italic">
                        {course.title}
                    </span>
                </button>
                <Link to={getLinkToDetail(selectedCourseClass)} className="text-gray-800 no-underline">
                    <h1 className="text-2xl font-bold space-x-1">
                        <span className="underline">{t("course_class")}:</span>
                        <span>{selectedCourseClass.title}</span>
                    </h1>
                </Link>
                <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-color-300 italic">
                    {selectedCourseClass?.course_class_idcode && (
                        <span className="font-mono font-semibold text-blue-500 not-italic tracking-wider">
                            #{selectedCourseClass.course_class_idcode}
                        </span>
                    )}
                    {firstCoordinator && (
                        <span className="flex items-center gap-1">
                            <GoDotFill size={8} className="text-color-400"/>
                            {`${t('teacher')} :`}
                            <span className="font-semibold text-color-100 not-italic tracking-wider">
                                {firstCoordinator?.teacher_name}
                            </span>
                        </span>
                    )}
                    <span className="flex items-center gap-1 text-xs tracking-wider">
                        <GoDotFill size={8} className="text-color-400"/>
                        <span className="text-color-100 not-italic">
                            <label className="font-bold">
                                {selectedCourseClass?.number_of_students ?? 0}
                            </label> {t('student').toLowerCase()}
                        </span>
                    </span>
                    {class_subjects.length > 0 && (
                        <span className="flex items-center flex-wrap gap-1">
                            <GoDotFill size={8} className="text-color-400"/>
                            {class_subjects.map((cs, i) => (
                                <span key={i} className="text-xs font-medium text-color-100 not-italic tracking-wider">
                                    {getTitle(cs.subject ?? cs)}
                                    {i < class_subjects.length - 1 && <span className="text-color-400">,</span>}
                                </span>
                            ))}
                        </span>
                    )}
                </div>
            </div>

            <TabNavigation
                tabs={CLASS_TABS}
                activeTab={activeTab}
                className="mt-6 border-color-300"
                style={{top: 'calc(3.9 * var(--header-height))', zIndex: 12}}
                onTabChange={(value) => {
                    onChangeSearchParams({"course-class-detail-tab": value})
                    setActiveTab(value)
                }}
            />

            <div className="p-3 md:p-6 background rounded-b-xl shadow-lg">
                {renderCourseClassContent()}
            </div>

            {courseClassModal}
            <div className="h-20"/>
        </div>
    );
};


export default CourseClassDetail
